export enum FieldType {
	Address = 'Address',
	AutoNumber = 'Auto Number',
	Checkbox = 'Checkbox',
	ComplexValue = 'Complex Value',
	Content = 'Content',
	Currency = 'Currency',
	Date = 'Date',
	DateTime = 'Date/Time',
	Email = 'Email',
	Encrypted = 'Encrypted',
	ExternalLookup = 'External Lookup',
	Fax = 'Fax',
	File = 'File',
	Formula = 'Formula',
	Geolocation = 'Geolocation',
	Hierarchy = 'Hierarchy',
	Html = 'Html',
	IndirectLookup = 'Indirect Lookup',
	IpAddress = 'IP Address',
	LongTextArea = 'Long Text Area',
	Lookup = 'Lookup',
	MasterDetail = 'Master-Detail',
	MetadataRelationship = 'Metadata Relationship',
	MultiselectPicklist = 'Multiselect Picklist',
	Name = 'Name',
	Number = 'Number',
	Percent = 'Percent',
	Phone = 'Phone',
	Picklist = 'Picklist',
	RichTextArea = 'Rich Text Area',
	RollUpSummary = 'Roll-Up Summary',
	Summary = 'Summary',
	Text = 'Text',
	TextArea = 'TextArea',
	Time = 'Time',
	Url = 'Url'
}
